import type {Result, UseCase} from 'framework';
import type {WeightTrackingError} from '../../domain/errors';
import type {WeightEntry} from '../../domain/weight-entry';
import type {
  WeightSeriesRange,
  WeightTrackingRepository,
} from '../ports/weight-tracking.repository';

export class GetWeightSeries implements UseCase<[WeightSeriesRange], readonly WeightEntry[]> {
  constructor(private readonly repository: WeightTrackingRepository) {}

  execute(range: WeightSeriesRange): Promise<Result<readonly WeightEntry[], WeightTrackingError>> {
    return this.repository.getSeries(range);
  }
}
